<template>
    <Paper class="banner-root">
        <div v-if="img" class="image-wrapper">
            <img class="image" :src="img" />
        </div>
        <div class="p-4">
            <h4>{{ title }}</h4>
            <h6 class="caption">{{ body }}</h6>
        </div>
    </Paper>
</template>

<script>
export default {
    name: 'Banner',
    props: {
        img: String,
        title: String,
        body: String,
    },
};
</script>

<style scoped>
.banner-root {
    overflow: hidden;
    background-color: #e6e6e6;
}

.image-wrapper {
    width: 100%;
    height: 300px;
}

.image {
    width: 100%;
    height: inherit;
    object-fit: cover;
}

@media only screen and (max-width: 600px) {
    .image-wrapper {
        height: 175px;
    }
}
</style>
